import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { getCategories } from "../../store/actions/categoryActions";
import CategoryCard from "../cards/CategoryCard";

const PageBody = styled.div`
  padding: 1.5rem 0 2rem;
`;

const ContentWrap = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const Meta = styled.p`
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  margin: 0 0 1rem;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
`;

const Empty = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 3rem;
  text-align: center;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

export default function CategoryBrowseGroups() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const categories = useSelector((s) => s.category.categories) || [];
  const loading = useSelector((s) => s.category.loading);
  const error = useSelector((s) => s.category.error);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const sorted = useMemo(
    () =>
      [...categories].sort((a, b) =>
        String(a.name || "").localeCompare(String(b.name || ""), undefined, {
          sensitivity: "base",
        })
      ),
    [categories]
  );

  if (loading && !categories.length) {
    return (
      <PageBody>
        <ContentWrap>
          <Empty>Loading categories…</Empty>
        </ContentWrap>
      </PageBody>
    );
  }

  if (error) {
    return (
      <PageBody>
        <ContentWrap>
          <Empty>{error}</Empty>
        </ContentWrap>
      </PageBody>
    );
  }

  if (!sorted.length) {
    return (
      <PageBody>
        <ContentWrap>
          <Empty>{t("categories.emptyList")}</Empty>
        </ContentWrap>
      </PageBody>
    );
  }

  return (
    <PageBody>
      <ContentWrap>
        <Meta>
          {sorted.length} categor{sorted.length !== 1 ? "ies" : "y"} found
        </Meta>
        <Grid>
          {sorted.map((cat) => (
            <CategoryCard key={cat.slug} category={cat} />
          ))}
        </Grid>
      </ContentWrap>
    </PageBody>
  );
}
